import React from 'react';
import Whale from './whale.svg'

export default function Logo(props) {
  return (
    <>
        <img src={Whale} alt='Whale`s tracker' />
    </>
  );
}